module.exports = __webpack_public_path__ + "img/new_btn_tablast_active.74db5f5b.png";